import { gql } from '@apollo/client';

export const GET_KB_WEBSITE_URLS_QUERY = gql`
  query GetKbWebsiteUrls {
    getKbWebsiteUrls {
      statusCode
      message
      urls {
        id
        url
        isActive
        createdAt
        updatedAt
      }
    }
  }
`;
